import ProvinceActions from './Actions'
import { Chip } from '@mui/material'

export const getColumns = (onEdit, onDelete, onRefresh, countryMap = {}) => [
  { field: 'id', headerName: 'ID', headerAlign: 'center', width: 70 },
  {
    field: 'nombre',
    headerName: 'Nombre',
    headerAlign: 'center',
    flex: 2,
    minWidth: 160,
  },
  {
    field: 'pais',
    headerName: 'País',
    headerAlign: 'center',
    flex: 1.5,
    minWidth: 140,
    valueGetter: params => countryMap[params.row.idPais] || params.row.idPais || '-',
  },
  {
    field: 'habilitado',
    headerAlign: 'center',
    headerName: 'Estado',
    flex: 1,
    minWidth: 100,
    renderCell: params => (
      <Chip
        label={params.value ? 'Activo' : 'Inactivo'}
        color={params.value ? 'success' : 'default'}
        size="small"
        variant="outlined"
      />
    ),
  },
  {
    field: 'actions',
    headerAlign: 'center',
    headerName: 'Acciones',
    type: 'actions',
    renderCell: params => (
      <ProvinceActions {...{ params, onEdit, onDelete, onRefresh }} />
    ),
    minWidth: 150,
    flex: 1.5,
  },
]
